module.exports = __webpack_public_path__ + "static/media/marathonEvent.dd588fa7.jpg";